import * as THREE from "three"

import Home from "./Home.js";
import { OrbitControls } from "three/examples/jsm/Addons.js";
export default class Camera {

    constructor() {
        this.home = new Home()
        this.sizes = this.home.sizes
        this.scene = this.home.scene
        this.canvas = this.home.canvas


        this.setInstance()
        // this.setOrbitControls()

    }

    setInstance() {
        const frustumSize = 20
        const aspect = this.sizes.width / this.sizes.height
        this.instance = new THREE.OrthographicCamera(
            -frustumSize * aspect / 2,
            frustumSize * aspect / 2,
            frustumSize / 2,
            -frustumSize / 2,
            0.1,
            100
        )
        // this.instance = new THREE.PerspectiveCamera(35, this.sizes.width / this.sizes.height, 0.1, 100)
        this.instance.position.set(0, 0, 9)

        this.scene.add(this.instance)

    }

    setOrbitControls() {
        this.controls = new OrbitControls(this.instance, this.canvas)
        this.controls.enableDamping = true
    }

    resize() {
        const frustumSize = 20
        const aspect = this.sizes.width / this.sizes.height

        this.instance.left = -frustumSize * aspect / 2
        this.instance.right = frustumSize * aspect / 2
        this.instance.top = frustumSize / 2
        this.instance.bottom = -frustumSize / 2

        this.instance.updateProjectionMatrix()
    }

    update() {
        // this.controls.update()
    }
}